import { defaultBasics } from "@/lib/schema/basics";
import { TResume } from "@/lib/store/resume";
import classNames from "classnames";

export const isUrl = (string: string | null | undefined) => {
  if (!string) return false;

  const urlRegex = /https?:\/\/[^ \n]+/i;

  return urlRegex.test(string);
};

type PictureProps = {
  resume: TResume;
  className?: string;
};

export const Picture = ({ resume, className }: PictureProps) => {
  const basics = resume.data.basics || defaultBasics;
  const pictureOptions = resume.data.basics?.pictureOptions;

  if (!isUrl(basics.picture) || pictureOptions?.hidden) return null;

  const pictureSize = pictureOptions?.size || 120;
  const pictureAspectRatio = pictureOptions?.aspectRatio || 1;
  const pictureBorderRadius = pictureOptions?.borderRadius || 0;
  const fontSize = resume.data.settings?.typography.font.size || 14;

  return (
    <img
      src={basics.picture}
      alt="Profile"
      className={classNames(
        className,
        "relative z-20 object-cover",
        pictureOptions?.border && "border-resume-primary",
      )}
      style={{
        maxWidth: `${pictureSize}px`,
        aspectRatio: `${pictureAspectRatio}`,
        borderRadius: `${pictureBorderRadius}px`,
        borderWidth: `${pictureOptions?.border ? fontSize / 3 : 0}px`,
      }}
    />
  );
};
